import React, { useEffect, useState } from "react";


export default function CoinsAPI() {

  const [onePrice, setOnePrice] = useState('');
  const [twoPrice, setTwoPrice] = useState('');

  useEffect(() => {
    fetch('https://api.coingecko.com/api/v3/coins')
    .then((response) => response.json())
    .then((data) => {
      const onePrice = data[0].market_data.current_price.usd
      const twoPrice = data[1].market_data.current_price.usd
      // data.map((item) => {
      //   console.log(item.market_data.current_price.usd)
        setOnePrice(onePrice)
        setTwoPrice(twoPrice)
    
    })
  }, [])


  return (
    <div>
      <div className="coin-container">
        <div className='coin-price'>
          <img src={require('../logos/btc-logo.png')} />
          <h1>Bitcoin:</h1>
          <h2 className="price">${onePrice}</h2>
        </div>
        <div className='coin-price'>
          <img src={require('../logos/eth-logo.png')} />
          <h1>Ethereum:</h1>
          <h2 className="price">${twoPrice}</h2>
        </div>
      </div>
    </div>
  );
}